export default [
  {
    path: '/production-demand',
    name: 'ProductionDemand',
    component: () => import('@/layouts/main.vue'),
    redirect: '/production-list',
    children: [
      {
        path: 'production-list',
        name: 'ProductionDemandProductionList',
        component: () => import('@/views/production-demand/production/list.vue'),
        meta: {
          icon: 'home',
          title: '生产信息',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'production-edit/:id',
        name: 'ProductionDemandProductionEdit',
        component: () => import('@/views/production-demand/production/edit.vue'),
        meta: {
          icon: 'home',
          title: '生产信息编辑',
          noCache: false,
          auth: true,
          activeMenu: 'ProductionDemandProductionList',
        },
      },
      {
        path: 'order-list',
        name: 'ProductionDemandOrderList',
        component: () => import('@/views/production-demand/order/list.vue'),
        meta: {
          icon: 'home',
          title: '订单信息',
          noCache: false,
          auth: true,
        },
      },
      {
        path: 'order-edit/:id',
        name: 'ProductionDemandOrderEdit',
        component: () => import('@/views/production-demand/order/edit.vue'),
        meta: {
          icon: 'home',
          title: '订单信息编辑',
          noCache: false,
          auth: true,
          activeMenu: 'ProductionDemandOrderList',
        },
      },
    ],
  },
];
